import React from 'react';
import { WizardContainer } from 'modules/product/wizard/pages';
import { ProductEditViewStore } from 'modules/product/stores';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ProductEditViewStore(rootStore), 'productEditViewStore')
@observer
class ProductEdit extends React.Component {
	render() {
		const {
			productEditViewStore: {
				config,
				form,
				localStorageKey,
				isUpdateMethod,
				applyToAllActiveOrdersConfirmModal,
				loading,
				handleBackButtonClick,
			},
		} = this.props;
		return (
			<div>
				<WizardContainer
					config={config}
					itemName={isUpdateMethod ? 'PRODUCT.UPDATE' : 'PRODUCT.CREATE'}
					form={form}
					localStorageKey={localStorageKey}
					applyToAllActiveOrdersConfirmModal={applyToAllActiveOrdersConfirmModal}
					disabled={loading}
					goBack={handleBackButtonClick}
				/>
			</div>
		);
	}
}

export default ProductEdit;



// WEBPACK FOOTER //
// ./src/modules/product/pages/ProductEdit.jsx